import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useFitnessManagerContext } from '../../FitnessManager/FitnessManagerContext';
import { LazyLoader } from '../../LazyLoader/LazyLoader';
import SettingsModal from '../../SettingsModal/SettingsModal';
import {
  ActivityTypes,
  DatePicker,
  Distance,
  Duration,
  Elevation,
  ImageUpload,
  Steps,
  Story,
  Title,
} from '../ManualFitnessEntryForm/ManualFitnessEntryForm';
import { FitnessApplicationActivityType } from '../../../../types/__generated__';

const ManualFitnessEntryForm = React.lazy(() =>
  import('../ManualFitnessEntryForm/ManualFitnessEntryForm'),
);

export interface ManualFitnessEntryProps {
  children: ReactNode;
  title: string;
  activities: FitnessApplicationActivityType[];
}

export const ManualFitnessEntryModal = ({
  children,
  title,
  activities,
}: ManualFitnessEntryProps) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { page, modalManager } = useFitnessManagerContext();

  return (
    <SettingsModal
      title={page.title}
      onCloseRequest={modalManager.actions.onCloseModal}
      aria-label={t('manualFitness.modalLabel')}
    >
      <LazyLoader>
        <ManualFitnessEntryForm title={title} activities={activities}>
          {children}
        </ManualFitnessEntryForm>
      </LazyLoader>
    </SettingsModal>
  );
};

ManualFitnessEntryModal.DatePicker = DatePicker;
ManualFitnessEntryModal.ActivityTypes = ActivityTypes;
ManualFitnessEntryModal.Distance = Distance;
ManualFitnessEntryModal.Elevation = Elevation;
ManualFitnessEntryModal.Duration = Duration;
ManualFitnessEntryModal.Title = Title;
ManualFitnessEntryModal.Story = Story;
ManualFitnessEntryModal.ImageUpload = ImageUpload;
ManualFitnessEntryModal.Steps = Steps;
